import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';
import { SavedSelection } from '@pages/Home/context/TerritorySelectionContext';

export type SalesFocusChain = components['schemas']['RestaurantChainSummary'];
export type SalesFocusIndependent = components['schemas']['IndependentLocationSummary'];
type RestaurantDataResponse = components['schemas']['RestaurantDataResponse'];

interface TerritoryParams {
    states?: string[];
    metros?: number[];
}

interface SalesFocusData {
    chains: SalesFocusChain[];
    independents: SalesFocusIndependent[];
    independentsUrl: string | null;
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get sales focus data';

const DEFAULT_DATA: SalesFocusData = { chains: [], independents: [], independentsUrl: null };

function buildTerritoryParams(savedSelection: SavedSelection | null): TerritoryParams {
    if (!savedSelection || savedSelection.ids.length === 0) return {};
    return savedSelection.mode === 'state'
        ? { states: savedSelection.ids }
        : { metros: savedSelection.ids.map(Number) };
}

async function getSalesFocusData(
    savedSelection: SavedSelection | null,
): Promise<SalesFocusData> {
    const response: RestaurantDataResponse = await http.get(
        REQUEST_TYPE,
        buildTerritoryParams(savedSelection),
    );
    return {
        chains: response?.chains ?? [],
        independents: response?.independents ?? [],
        independentsUrl: response?.independentsUrl ?? null,
    };
}

export function useSalesFocusData(savedSelection: SavedSelection | null) {
    return useData(DEFAULT_DATA, getSalesFocusData, savedSelection);
}
